import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { useDebounce } from './SearchDebouncer';
import './SelectMaterial.css';
import trashIcon from './images/remove.svg';

const searchMaterials = async (name, token) => {
  const apiUrl = process.env.REACT_APP_BACKEND_API;

  const response = await fetch(
    `${apiUrl}/materials/search?name=${encodeURIComponent(name)}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.json();
};

export default function SelectMaterial({
  setMaterials,
  setTotalExpense,
  closeShowWorkLogModal,
}) {
  const token = localStorage.getItem('token');

  const [inputValue, setInputValue] = useState('');
  const [withdrawnQuantity, setWithdrawnQuantity] = useState('');
  const [usedQuantity, setUsedQuantity] = useState('');
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [showMaterialList, setShowMaterialList] = useState(false);
  const debouncedValue = useDebounce(inputValue, 500);

  const { data: searchedMaterials = [] } = useQuery(
    ['materials', debouncedValue],
    () => searchMaterials(debouncedValue, token),
    {
      enabled: !!debouncedValue && !!token,
    }
  );

  const handleSelect = (material) => {
    setSelectedMaterial(material);
    setInputValue('');
  };

  const handleMaterialAddition = () => {
    setMaterials((prevState) => {
      return [
        ...prevState,
        {
          currentPriceRate: parseFloat(selectedMaterial.unitPrice),
          withdrawnQuantity: parseFloat(withdrawnQuantity),
          usedQuantity: parseFloat(usedQuantity),
          material: selectedMaterial,
        },
      ];
    });

    setTotalExpense(
      (prevTotal) =>
        prevTotal + parseFloat(selectedMaterial.unitPrice * usedQuantity)
    );
    closeShowWorkLogModal();
  };

  return (
    <div
      className="select-material-container"
      onClick={() => setShowMaterialList(false)}
    >
      <h3 className="select-material-label">Odaberi materijal</h3>

      {selectedMaterial ? (
        <div className="selected-material-container">
          <input
            type="text"
            value={selectedMaterial.name}
            onChange={(e) => setInputValue(e.target.value)}
            className="material-search-input material-selected-input"
            disabled
          />
          <img
            className="remove-selected-material"
            src={trashIcon}
            onClick={() => {
              setSelectedMaterial(null);
            }}
            alt="Icon"
            width={'12'}
          />
        </div>
      ) : (
        <>
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Pretraži materijale..."
            className="material-search-input"
            onClick={(e) => {
              e.stopPropagation();
              setShowMaterialList(true);
            }}
          />
          <div className="select-material-list">
            {searchedMaterials.length > 0 && showMaterialList && (
              <>
                {searchedMaterials.map((material, index) => (
                  <div
                    key={material.name}
                    onClick={() => handleSelect(material)}
                    className={`${'material-details'} ${
                      searchedMaterials.length === 1
                        ? 'single-material-element'
                        : index === 0
                        ? 'first-material-element'
                        : index === searchedMaterials.length - 1
                        ? 'last-material-element'
                        : ''
                    }`}
                  >
                    {material.name}{' '}
                    <label className="storage-quantity-text">{`(${parseInt(
                      material.inStock
                    ).toFixed(0)})`}</label>
                  </div>
                ))}
              </>
            )}
          </div>
        </>
      )}

      <h3 className="select-material-label material-quantity-label">
        Izuzeta količina{' '}
        {selectedMaterial && `(${selectedMaterial.measurementUnit})`}
      </h3>
      <input
        type="number"
        value={withdrawnQuantity}
        onChange={(e) => setWithdrawnQuantity(e.target.value)}
        placeholder="0"
        className="material-search-input"
      />

      <h3 className="select-material-label material-quantity-label">
        Iskorištena količina{' '}
        {selectedMaterial && `(${selectedMaterial.measurementUnit})`}
      </h3>
      <input
        type="number"
        value={usedQuantity}
        onChange={(e) => setUsedQuantity(e.target.value)}
        placeholder="0"
        className="material-search-input"
      />
      <div>
        <button
          className="add-material-button"
          type="button"
          onClick={handleMaterialAddition}
          disabled={
            selectedMaterial === null ||
            Number(withdrawnQuantity) <= 0 ||
            Number(usedQuantity) < 0 ||
            Number(usedQuantity) > Number(withdrawnQuantity)
          }
        >
          Dodaj materijal
        </button>
      </div>
    </div>
  );
}
